import React from 'react';
import { CTAButton } from './CTAButton';
export function ClosingSection() {
  return <section className="bg-dark py-28 md:py-32 px-4" data-id="element-49">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center text-center" data-id="element-50">
        <h2 className="font-serif text-4xl md:text-6xl font-bold text-textLight mb-16" data-id="element-51">
          Ya sabes que algo no está bien.
        </h2>

        <div className="text-xl md:text-2xl text-textLight mb-20 space-y-2 font-medium leading-relaxed" data-id="element-52">
          <p data-id="element-53">No porque te falte capacidad,</p>
          <p data-id="element-54">sino porque estás sosteniendo demasiado.</p>
          <p data-id="element-55">Puedes seguir igual y repetir el mismo mes.</p>
          <p data-id="element-56">O puedes hacer un ajuste hoy.</p>
        </div>

        <div className="mb-20" data-id="element-57">
          <p className="font-serif text-3xl md:text-5xl text-textLight font-bold leading-tight space-y-4" data-id="element-58">
            <span className="block" data-id="element-59">90 minutos.</span>
            <span className="block" data-id="element-60">$15.</span>
            <span className="block" data-id="element-61">Una nueva forma de operar tu negocio.</span>
          </p>
        </div>

        <CTAButton className="mb-24 w-full md:w-auto" data-id="element-62">
          QUIERO AJUSTAR MI NIVEL AHORA
        </CTAButton>

        <div className="text-center" data-id="element-63">
          <p className="font-serif italic text-xl md:text-2xl text-textSecondary font-bold tracking-wide mb-4" data-id="element-64">
            VENDER SIN FUGAS. CRECER SIN ROMPERTE.
          </p>
          <p className="text-textSecondary text-lg" data-id="element-65">— Carolina Gómez</p>
        </div>
      </div>
    </section>;
}